
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { FormsModule } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { Meta, Title } from '@angular/platform-browser'
import { Router, RouterModule } from '@angular/router'
import { SITE_TITLE } from '../../../shared/constants'

@Component({
  selector: 'app-calorie-calculator',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule
],
  templateUrl: './calorie-calculator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './calorie-calculator.component.scss'
})
export class CalorieCalculatorComponent {
  constructor(
    private meta: Meta,
    private title: Title,
    public http: HttpClient,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.calorieForm = this.fb.group({
      age: ['', [Validators.required, Validators.min(1)]],
      weight: ['', [Validators.required, Validators.min(1)]],
      height: ['', [Validators.required, Validators.min(1)]],
      gender: ['', [Validators.required]],
      activityLevel: ['', [Validators.required]]
    })
  }

  public calorieForm: FormGroup

  calorieResultStr: string | null = null
  calorieResult: number | null = null

  ngOnInit() {
    this.title.setTitle(SITE_TITLE + " | Calorie Calculator")
    this.meta.updateTag({ name: 'description', content: 'Calculate your daily calorie needs with our free online Calorie Calculator.' })
    this.meta.updateTag({ name: 'keywords', content: 'calorie, calculator, daily calorie needs, calculate, tool, free' })

    this.calculateCalories()
  }

  onSubmit() {
    this.calculateCalories()
  }

  calculateCalories() {
    if (this.calorieForm.valid) {
      const age = this.calorieForm.value.age
      const weight = this.calorieForm.value.weight
      const height = this.calorieForm.value.height
      const gender = this.calorieForm.value.gender
      const activityLevel = this.calorieForm.value.activityLevel as keyof typeof activityMultiplier

      let bmr: number

      if (gender === 'male') {
        bmr = 88.362 + (13.397 * weight) + (4.799 * height) - (5.677 * age)
      } else {
        bmr = 447.593 + (9.247 * weight) + (3.098 * height) - (4.330 * age)
      }

      const activityMultiplier = {
        'sedentary': 1.2,
        'light': 1.375,
        'moderate': 1.55,
        'active': 1.725,
        'very active': 1.9
      }

      this.calorieResult = bmr * activityMultiplier[activityLevel]
      this.calorieResultStr = this.calorieResult.toFixed(2)
    }

  }
}
